import React from "react";

export const formatText = (text: string) => {
    const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);

    return parts.map((part: string, i: number) => {
        if (/^\*\*[^*]+\*\*$/.test(part)) {
            return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        if (/^\*[^*]+\*$/.test(part)) {
            return <em key={i}>{part.slice(1, -1)}</em>;
        }
        return part;
    });

};
